import React from 'react';
import styles from './CartItem.module.scss';
import currency from 'currency.js';
import Delete from '../../../icons/Delete';
import { isRetouchingExtra } from '../../../../utils/offerPricing';

// `waivesRetouching` is the cart's server-computed flag (Api::CartResource ->
// Cart#waives_retouching?), threaded down from the cart page rather than read off
// `orderPackage.cart` -- the cart page does not sideload that back-reference, so
// reading it here would silently be undefined and the row would never show Free.
//
// The struck-out price stays in the line total and in the Subtotal on purpose: the
// waiver is money the COUPON pays, so it is accounted for in the Discount line
// (Coupon.calculate_discount takes the retouching charge off first, then applies the
// percentage to the rest). Dropping it here as well would double-count it and leave
// the line items no longer summing to the Subtotal. Same treatment the Shipping line
// in the summary already gets for a free-shipping coupon: fee struck out, FREE
// beside it, the real waiver in the totals.
export default function Extras({ orderPackage, removeItem, editable, waivesRetouching }) {
  return (
    <div className={styles.extrasWrapper}>
      {orderPackage.orderPackageExtras.map((orderPackageExtra) => {
        if (!orderPackageExtra.extra) return null;

        const priceWithout = orderPackageExtra.extra.prices[0].priceWithout;
        const priceWith = orderPackageExtra.extra.prices[0].price;
        const price = orderPackage.price === 0 && priceWithout ? priceWithout : priceWith;
        const waived = !!waivesRetouching && isRetouchingExtra(orderPackageExtra.extra);

        return (
          <div className={styles.extras} key={orderPackageExtra.id}>
            <div className={styles.extra}>
              <div>{orderPackageExtra.extra.name}</div>
              <div>
                {waived ? (
                  <>
                    <span className={styles.wasPrice}>{currency(price).format()}</span>
                    <span className={styles.freePrice}>FREE</span>
                  </>
                ) : currency(price).format()}
              </div>
            </div>
            {editable && (
              <div className={styles.grayscaled}>
                <Delete onClick={() => removeItem(orderPackageExtra.id, 'extras')}/>
              </div>
            )}
          </div>
        )
      })}
    </div>
  )
}
